import { Field, Form, FormSpy } from 'react-final-form';
import { FormState } from 'final-form';
import {
  AccountAdminData,
  US_COUNTRY_CODE,
} from '../../../../state/enrollment/enrollmentModel';
import {
  getCountryOpts,
  getStateOpts,
  isUSState,
  parseAddressCity,
  parseAddressZip,
  parsePhoneNumber,
  parseStreetAddress,
  validateAccountAdminForm,
} from '../utils/functions';
import styles from './AccountAdminForm.module.scss';
import classNames from 'classnames/bind';
import TextInput from '../../../../components/FormComponents/TextInput';
import DropdownField from '../../../../components/FormComponents/DropdownField';
import { DropdownMenuOption } from '../../../../components/DropdownMenu/DropdownMenu';
import Button from '../../../../components/Button';

const cx = classNames.bind(styles);

const stateOpts: DropdownMenuOption[] = getStateOpts();
const countryOpts: DropdownMenuOption[] = getCountryOpts();

interface AccountAdminFormProps {
  title: string;
  initialValues: AccountAdminData;
  isLoading: boolean;
  onSubmit: () => void;
}

export const AccountAdminForm = (props: AccountAdminFormProps) => {
  const { title, initialValues, isLoading, onSubmit } = props;

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={initialValues}
      validate={validateAccountAdminForm}
      render={({ handleSubmit, valid, values, form }) => (
        <form onSubmit={handleSubmit}>
          <label className={cx('account-admin-form__label')}>{title}</label>
          <Field
            name="email"
            component={TextInput}
            placeholder="Email address (required)"
            tooltip="Enter your business email address.  The same address should be used to log into your DFIN Applications and Login.gov (if applicable)."
          />
          <Field
            name="firstName"
            component={TextInput}
            placeholder="First name (required)"
          />
          <Field
            name="lastName"
            component={TextInput}
            placeholder="Last name (required)"
          />
          <Field
            name="addressLine1"
            component={TextInput}
            parse={parseStreetAddress}
            placeholder="Business address street 1 (required)"
          />
          <Field
            name="addressLine2"
            component={TextInput}
            parse={parseStreetAddress}
            placeholder="Business address street 2 (optional)"
          />
          <Field
            name="city"
            component={TextInput}
            parse={parseAddressCity}
            placeholder="Business address city (required)"
          />
          <Field
            name="state"
            component={DropdownField}
            options={stateOpts}
            placeholder="Business state/territory (required)"
          />
          <FormSpy
            subscription={{ values: true }}
            onChange={(formState: FormState<AccountAdminData>) =>
              isUSState(formState.values.state) &&
              form.change('country', US_COUNTRY_CODE)
            }
          />
          <Field
            name="country"
            component={DropdownField}
            options={countryOpts}
            placeholder="Business province/country (required)"
            isDisabled={isUSState(values.state)}
          />
          <Field
            name="zipCode"
            component={TextInput}
            parse={parseAddressZip}
            placeholder="Business address zip (required)"
          />
          <Field
            name="phoneNumber"
            component={TextInput}
            parse={parsePhoneNumber}
            placeholder="Business phone number (required)"
          />
          <div className={cx('account-admin-form__footer')}>
            <Button
              onClick={() => handleSubmit()}
              disabled={!valid}
              className={cx('account-admin-form__save-btn')}
              isLoading={isLoading}
            >
              Save & Continue
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default AccountAdminForm;
